import { createAction } from '@reduxjs/toolkit';
import { actionType } from '../../services/utils';
const types = {
  SET_TOKENS: actionType('SET_TOKENS'),
  DELETE_TOKENS: actionType('DELETE_TOKENS')
};
export const setTokens = createAction(types.SET_TOKENS);
export const deleteTokens = createAction(types.DELETE_TOKENS);